// https://vuex.vuejs.org/en/getters.html
import { Ability } from '@casl/ability'

export default {
  token: state => state.user.token,
  name: state => state.user.name,
  role: state => state.user.role,
  loading: state => state.app.loading,
  user: state => state.user,

  accountDialog: state => state.app.accountDialog,
  accountItem: state => state.app.accountItem,

  s3BaseUrl: state => state.app.s3BaseUrl,
  siteUrl: state => state.app.siteUrl,
 
  snackbar: state => state.app.snackbar,
  ability: () => {
    return new Ability([
      { action: ['read'], subject: ['all'] }
    ])
  },
  changePass: state => state.app.changePass,
}
